import React, { Component } from 'react';

import * as validationHelper from '../../../helpers/validationHelper';

import { Form, Icon, Popup } from 'semantic-ui-react';

import { FIELD_INVALID } from '../../../constants/errorMessages';

import './index.css';

class FormbuilderFieldWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applyValidation: props.initialValidation ? props.initialValidation : false
    }
  }

  onBlur = () => {
    this.setState(({
      applyValidation: true
    }));

    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  render() {
    const { label, error, required, popup, inputSub, errorMessage, validation, value, identifier } = this.props;
    const validationError = this.state.applyValidation && validation && !validationHelper.isValid(validation, value);
    const isError = validationError || error;
    const isRequired = required || (validation && validation.required);

    return (
      <Form.Field error={isError} required={isRequired} key={identifier}
        onBlur={this.onBlur}>
        {label &&
          <label className={popup && "info-included"}>
            {label}
            {popup &&
              <Popup trigger={<Icon name="info circle" className="info-popup" />} size="mini" position="top right" basic content={popup} />
            }
          </label>
        }
        {this.props.children}
        {isError &&
          <p className="c-error">{validationHelper.getValidationErrorMessage(validation, value) || errorMessage || FIELD_INVALID}</p>
        }
        {inputSub &&
          <div className="input-sub">{inputSub}</div>
        }
      </Form.Field>
    );
  }
}

export default FormbuilderFieldWrapper;
